import React from "react";
import { Link } from "react-router-dom";
import logoImage from "../../assets/img/logo/logo.svg";
import { scrollToTop } from "../../lib/helpers";
import { useLanguage } from "../../context/LanguageContext";

const FooterOne = () => {
  const { t } = useLanguage();

  return (
    <footer>
      <div className="footer-area">
        <div className="container">
          <div className="footer-scroll-wrap">
            <button
              className="scroll-to-target"
              data-target="html"
              onClick={scrollToTop}
            >
              <i className="fas fa-arrow-up"></i>
            </button>
          </div>
          <div className="footer-top">
            <div className="row justify-content-center">
              <div className="col-xl-4 col-lg-5 col-md-6">
                <div
                  className="footer-widget wow fadeInUp"
                  data-wow-delay=".2s"
                >
                  <Link to="/" className="f-logo">
                    <img
                      src={logoImage}
                      alt="Realiste Logo"
                      width="250"
                      height="100"
                    />
                  </Link>
                  <div className="footer-content">
                    <p>{t("footer.description")}</p>
                    <ul className="footer-social">
                      <li>
                        <a
                          href="https://www.facebook.com/profile.php?id=61580254145406"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/realiste_hungary/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fab fa-tiktok"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-5 col-md-6">
                <div
                  className="footer-widget  wow fadeInUp"
                  data-wow-delay=".4s"
                >
                  <h4 className="fw-title">{t("footer.navigation")}</h4>
                  <div className="footer-link">
                    <ul>
                      <li>
                        <Link
                          to="#why-choose-us"
                          onClick={() => window.scrollTo(0, 0)}
                        >
                          {t("navigation.whyChooseUs")}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#market-growth"
                          onClick={() => window.scrollTo(0, 0)}
                        >
                          {t("navigation.marketGrowth")}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#megaprojects"
                          onClick={() => window.scrollTo(0, 0)}
                        >
                          {t("navigation.megaprojects")}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#dubai-vs-budapest"
                          onClick={() => window.scrollTo(0, 0)}
                        >
                          {t("navigation.dubaiVsBudapest")}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#contact"
                          onClick={() => window.scrollTo(0, 0)}
                        >
                          {t("navigation.startInvestment")}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="copyright-text">
                  <p>{t("footer.copyright")}</p>
                </div>
              </div>
              <div className="col-lg-6 d-none d-sm-block">
                <div className="footer-menu">
                  <ul>
                    <li>
                      <Link to="#">{t("footer.terms")}</Link>
                    </li>
                    <li>
                      <Link to="#">{t("footer.privacy")}</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterOne;
